import React from 'react';

const About = () => {
    return <h1>소개 페이지</h1>;
};

export default About;